import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'neq-group',
  templateUrl: './group.component.html'
})
export class NeqGroupComponent implements OnChanges {

  @Input() label: string;
  @Input() labelPosition: 'TOP' | 'LEFT' = 'TOP';
  @Input() direction: 'ROW' | 'COLUMN' = 'ROW';

  layout = 'column';
  layoutAlignment = 'start';

  contentLayout = 'row wrap';
  contentLayoutAlignment = 'start center';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['labelPosition']) {
      if (this.labelPosition === 'LEFT') {
        this.layout = 'row wrap';
        this.layoutAlignment = 'start center';
      } else {
        this.layout = 'column';
        this.layoutAlignment = 'start';
      }
    }

    if (changes['direction']) {
      if (this.direction === 'COLUMN') {
        this.contentLayout = 'column';
        this.contentLayoutAlignment = 'start';
      } else {
        this.contentLayout = 'row wrap';
        this.contentLayoutAlignment = 'start center';
      }
    }
  }

}
